import { requestAndParse, requestSuccessful } from '../request';

const deleteStudyParticipant = async (id: string) => {
    const route = 'admin/delete-study-participant';
    const payload = { id };

    const response = await requestAndParse(route, payload, 'DELETE');

    const success = requestSuccessful(response);
    const message = response.body?.message as string;

    return { success, message };
};

export default deleteStudyParticipant;
